import React from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';
import { isIE } from '../common/utils';

import './responsiveTable.scss';

class ResponsiveTable extends React.Component {
    render() {
        let typeClass = "";
        if (this.props.type === undefined || this.props.type === 'Normal') {
            // nothing
        } else if (this.props.type === 'OnlyMobile') {
            typeClass = "only-mobile";
        } else if (this.props.type === 'OnlyFullWidth') {
            typeClass = "only-full-width";
        }
        if (this.props.useSticky) {
            typeClass += " sticky-table-root"
        }
        return (
            <div className={classnames(`responsive-table ${typeClass}`,{"IE": isIE()})} style={this.props.style}>
                {this.props.children}
            </div>
        );
    }
}

ResponsiveTable.propTypes = {
    type: PropTypes.oneOf(['OnlyMobile', 'OnlyFullWidth', 'Normal'])
};

export default ResponsiveTable;

/*
    If you want use this responsive table, you need every td element define data-label
*/